import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { IApiResponse } from "../../../../@types/api-response.type";
import { IGroupForm, IGroupItem } from "../../../../@types/group.type";
import { getGroupById } from "../../../../services/api/groups/groupsService";
import { Permission } from "../Permission";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import CircularProgress from "@mui/material/CircularProgress";

function mapGroupItemToGroupForm(groupData: IGroupItem): IGroupForm {
  const groupForm: IGroupForm = {
    groupId: groupData.id,
    groupName: groupData.name,
    groupDescription: groupData.description,
    projectId: "",
    projectStatusId: "",
    allocationId: "",
    customerId: "",
    areaId: "",
    costCenterId: "",
    positionId: "",
    permissionId: "",
    userId: "",
    resourceId: "",
    tokenId: "",
    syncId: "",
    customFieldsId: "",
    availabilityId: "",
    holidaysId: "",
    financialContractedId: "",
    financialPlannedId: "",
    accountConfigurationId: "",
    reportsId: "",
    auditId: ""
  };

  groupData.features.forEach((feature) => {
    switch (feature.name) {
      case "Projetos":
        groupForm.projectId = feature.selectedAccessLevel.id || "";
        break;
      case "Status de Projetos":
        groupForm.projectStatusId = feature.selectedAccessLevel.id || "";
        break;
      case "Mapa de Alocação":
        groupForm.allocationId = feature.selectedAccessLevel.id || "";
        break;
      case "Clientes":
        groupForm.customerId = feature.selectedAccessLevel.id || "";
        break;
      case "Áreas":
        groupForm.areaId = feature.selectedAccessLevel.id || "";
        break;
      case "Centro de Custo":
        groupForm.costCenterId = feature.selectedAccessLevel.id || "";
        break;
      case "Funções":
        groupForm.positionId = feature.selectedAccessLevel.id || "";
        break;
      case "Permissões":
        groupForm.permissionId = feature.selectedAccessLevel.id || "";
        break;
      case "Usuários":
        groupForm.userId = feature.selectedAccessLevel.id || "";
        break;
      case "Colaboradores":
        groupForm.resourceId = feature.selectedAccessLevel.id || "";
        break;
      case "Tokens de API":
        groupForm.tokenId = feature.selectedAccessLevel.id || "";
        break;
      case "Sincronização de Dados":
        groupForm.syncId = feature.selectedAccessLevel.id || "";
        break;
      case "Campos Personalizados":
        groupForm.customFieldsId = feature.selectedAccessLevel.id || "";
        break;
      case "Disponibilidade Padrão":
        groupForm.availabilityId = feature.selectedAccessLevel.id || "";
        break;
      case "Feriados":
        groupForm.holidaysId = feature.selectedAccessLevel.id || "";
        break;
      case "Financeiro Contratado":
        groupForm.financialContractedId = feature.selectedAccessLevel.id || "";
        break;
      case "Financeiro Planejado":
        groupForm.financialPlannedId = feature.selectedAccessLevel.id || "";
        break;
      case "Configuração da Conta":
        groupForm.accountConfigurationId = feature.selectedAccessLevel.id || "";
        break;
      case "Relatórios":
        groupForm.reportsId = feature.selectedAccessLevel.id || "";
        break;
      case "Auditoria":
        groupForm.auditId = feature.selectedAccessLevel.id || "";
        break;
      default:
        break;
    }
  });

  return groupForm;
}

export const UpdateGroup: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [group, setGroup] = useState<IGroupForm>({} as IGroupForm);
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.permissions.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }

    async function fechGroupById() {
      try {
        setLoading(true);

        if (!id) {
          toast.error("ID do Grupo não fornecido!");
          navigate("/*");
          return;
        }

        const response = (await getGroupById(id)) as IApiResponse<IGroupItem>;

        if (!response.result) {
          toast.error("Grupo não encontrado!");
          navigate("/*");
          return;
        }
        const groupMap = mapGroupItemToGroupForm(response.result);
        setGroup(groupMap);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar o Grupo!");
      } finally {
        setLoading(false);
      }
    }

    fechGroupById();
  }, [id]);

  return (
    <>
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress size={100} />
        </div>
      ) : (
        <div>
          <Permission pageType="update" groupData={group} />
        </div>
      )}
    </>
  );
};
